import { useEffect } from "react";

import "./who-are-we.css";

const WhoAreWe = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className={"min-w-screen text-white max-w-[3840px] mx-auto"}>
      <div className="relative text-center">
        <img
          className="w-full mobile:h-[600px] h-[400px] opacity-50 xx-large:object-cover"
          alt="stadium"
          src={
            import.meta.env.VITE_APP_ASSETS_BASE_URL +
            "/fut23/who-are-we/stadium.png"
          }
        />
        <div className="absolute flex flex-col items-center transform -translate-x-1/2 -translate-y-1/2 w-4/5 mobile:w-auto top-1/2 left-1/2 gap-y-10">
          <div className="mobile:text-5xl text-3xl font-black mobile:w-[600px] w-full">
            Give your Ultimate Team the power of AI
          </div>
          <div className="mobile:text-xl text-base font-medium mobile:w-[700px] w-full text-center">
            Our mission is to empower players with advanced tools based on novel
            AI and technology. We want players to have more fun, build stronger
            teams and reach their full potential in FC 25 Ultimate Team.
          </div>
        </div>
      </div>
      {/* Partners.. */}
      <div className="w-full text-black bg-white ">
        <div className="max-w-[1680px] mx-auto flex mobile:flex-row flex-col justify-between items-center gap-x-8">
          <div className="flex flex-col mobile:w-[600px] w-4/5 ml-10 mx-auto mt-20">
            <p className="mobile:text-5xl font-black text-3xl">Our Partners</p>
            <p className="mobile:text-4xl font-extrabold">
              Supporting dreams of all sizes
            </p>
            <p className="mt-4 mobile:text-xl font-medium text-base">
              We want to grow and promote the FUT community that we have loved
              for years. We proudly partner with leading esports teams SAF and
              Team Dux, as well as collaborate with talented content creators
              and other FUT sites, doing our part to support them in achieving
              their goals and dreams.
            </p>
            <div className="flex flex-row mx-auto mt-4 mb-10 mobile:gap-x-16 gap-x-10 desktop:pr-4">
              <a
                href={"https://twitter.com/SAF_gg"}
                target="_blank"
                rel="noreferrer"
                className="rounded-full"
              >
                <img
                  className="mobile:w-48 mobile:h-48 w-28 h-28 partners_logo"
                  src={
                    import.meta.env.VITE_APP_ASSETS_BASE_URL +
                    "/fut23/who-are-we/saf.png"
                  }
                  alt="saf"
                />
              </a>
              <a
                href={"https://teamdux.com/"}
                target="_blank"
                rel="noreferrer"
                className="rounded-full"
              >
                <img
                  className="mobile:w-48 mobile:h-48 w-28 h-28 partners_logo"
                  src={
                    import.meta.env.VITE_APP_ASSETS_BASE_URL +
                    "/fut23/who-are-we/dux.png"
                  }
                  alt="dux"
                />
              </a>
            </div>
          </div>
          <img
            className="hidden mobile:block w-[500px] desktop:min-w-[400px] object-contain h-min bg-gray-300 my-auto mt-20 mobile:mb-20 mb-10 mr-20 desktop:mr-10"
            src={
              import.meta.env.VITE_APP_ASSETS_BASE_URL +
              "/fut23/who-are-we/saf-celebrating.png"
            }
            alt="saf-celebrating"
          />
        </div>
      </div>
      <div className="max-w-[1680px] mx-auto text-white flex mobile:flex-row flex-col-reverse justify-between items-center gap-x-8 mt-20 mb-20">
        <img
          className="mobile:w-[500px] desktop:min-w-[400px] w-4/5 bg-gray-300 my-auto desktop:ml-10 mt-10 mobile:mt-0 mx-auto mobile:mx-0 object-contain"
          src={
            import.meta.env.VITE_APP_ASSETS_BASE_URL +
            "/fut23/who-are-we/for-the-players.png"
          }
          alt="for-the-players"
        />
        <div className="flex flex-col large:w-[900px] ml-20 w-4/5 mobile:w-auto mr-20 desktop:mr-10 mx-auto mobile:mx-0 mobile:text-right text-left">
          <p className="mobile:text-5xl font-black text-3xl">
            For the players, by the players
          </p>
          <p className="mt-8 font-medium mobile:text-xl text-base max-w-[600px] w-full mobile:w-auto ml-auto mx-auto mobile:mx-0 text-left">
            Back in FIFA 22, we sat on a college sofa, trying to fit our own
            players into yet another chemistry SBC. We knew we couldn't be alone
            in our frustration, so we put all our effort into making an AI that
            could do it for us. Fast forward a year, and we're now living our
            dream, dedicating our full attention to a service that's trusted by
            over 1 million FUT players.
          </p>
        </div>
      </div>
      <div className="w-full text-black bg-white">
        <div className="max-w-[1680px] mx-auto flex mobile:flex-row flex-col justify-between items-center gap-x-8 ">
          <div className="flex flex-col mobile:w-[600px] w-4/5 ml-10 mx-auto mt-20 mb-10">
            <p className="mobile:text-5xl font-black text-3xl">
              Follow the rules, and protect your credentials
            </p>
            <p className="mt-8 mobile:text-xl font-medium text-base text-left">
              At EasySBC, we stand firmly against automation tools that
              interface with the FC 25 web app. We believe that such tools give
              you an unfair advantage, and compromise the integrity of the
              transfer market, which goes against EA's Terms of Service. That's
              why we work exclusively with content creators that are not
              involved with coin selling or any other activities breaking TOS.
            </p>
            <p className="mt-2 mobile:text-xl font-medium text-base text-left">
              It's important to note that our service never requires your EA
              credentials, and you should not share your login information with
              anyone from EasySBC or EA.
            </p>
          </div>
          <img
            className="mobile:w-[500px] desktop:min-w-[400px] ml-20 mobile:ml-0 w-4/5 bg-gray-300 my-auto mr-20 desktop:mr-10 mb-20 mx-auto object-contain h-min"
            src={
              import.meta.env.VITE_APP_ASSETS_BASE_URL +
              "/fut23/who-are-we/follow-rules.png"
            }
            alt="follow-rules"
          />
        </div>
      </div>
      <div className="flex mobile:flex-row items-center justify-between w-full text-white flex-col-reverse">
        <div className="flex flex-col mobile:w-[600px] w-4/5 mx-auto mt-20">
          <p className="mobile:text-5xl font-black text-center text-3xl">
            Want to know more?
          </p>
          <p className="mt-8 mobile:text-xl font-medium mobile:text-center text-base text-left">
            Join our Discord community to connect with us and other EasySBC
            users. Get a sneak peek at the features we're working on and provide
            us with valuable feedback. We're passionate about contributing to
            the FUT community that has brought us so much joy over the years,
            and we look forward to seeing you there!
          </p>
        </div>
      </div>
      <div className="flex w-full mb-20">
        <div className="flex flex-row mx-auto mobile:mt-12 mobile:gap-x-12 gap-x-2 mt-8">
          <a
            href={"https://discord.gg/mmNtdnUcJf"}
            className="rounded-full"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="mobile:w-32 mobile:h-32 w-16 h-16 social_logo"
              src={
                import.meta.env.VITE_APP_ASSETS_BASE_URL +
                "/fut23/who-are-we/discord.png"
              }
              alt="discord"
            />
          </a>
          <a
            href={"https://www.instagram.com/easysbc/"}
            className="rounded-full"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="mobile:w-32 mobile:h-32 w-16 h-16 social_logo"
              src={
                import.meta.env.VITE_APP_ASSETS_BASE_URL +
                "/fut23/who-are-we/instagram.png"
              }
              alt="instagram"
            />
          </a>
          <a
            href={"https://twitter.com/easysbc"}
            className="rounded-full"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="mobile:w-32 mobile:h-32 w-16 h-16 social_logo"
              alt="twitter"
              src={
                import.meta.env.VITE_APP_ASSETS_BASE_URL +
                "/fut23/who-are-we/twitter.png"
              }
            />
          </a>
          <a
            href={"https://www.tiktok.com/@easysbc"}
            target="_blank"
            rel="noreferrer"
            className="rounded-full"
          >
            <img
              className="mobile:w-32 mobile:h-32 w-16 h-16 social_logo"
              alt="tiktok"
              src={
                import.meta.env.VITE_APP_ASSETS_BASE_URL +
                "/fut23/who-are-we/_tiktok.png"
              }
            />
          </a>
        </div>
      </div>
    </main>
  );
};

export default WhoAreWe;
